import { render, staticRenderFns } from "./gTitle.vue?vue&type=template&id=8448ee16&scoped=true&"
import script from "./gTitle.vue?vue&type=script&lang=js&"
export * from "./gTitle.vue?vue&type=script&lang=js&"
import style0 from "./gTitle.vue?vue&type=style&index=0&id=8448ee16&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8448ee16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8448ee16')) {
      api.createRecord('8448ee16', component.options)
    } else {
      api.reload('8448ee16', component.options)
    }
    module.hot.accept("./gTitle.vue?vue&type=template&id=8448ee16&scoped=true&", function () {
      api.rerender('8448ee16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xmy/components/gTitle.vue"
export default component.exports